import { SECOND_PER_DAY } from '../constants'

export const secondsToDays = (seconds: number): number => {
  return Math.floor(seconds / (24 * 60 * 60))
}

export const formatRemainingTime = (remainingSeconds: number): string => {
  const remainingDays = Math.ceil(remainingSeconds / SECOND_PER_DAY)
  if (remainingDays > 1) {
    return `${remainingDays} days`
  }
  const remainingHours = Math.max(Math.ceil(remainingSeconds / 3600), 0)
  return `${remainingHours} ${remainingHours > 1 ? 'hours' : 'hour'}`
}
